import { ENRICHED } from '../constants/AccountCapability';
import { YOUTH_ACCOUNT_PAYMENT_LIMIT } from '../constants/YouthAccountConstants';
import AccountsStore from '../stores/AccountsStore';

export const isEnrichCapabilityAvailable = (account) => {
  /**
   * Unfortunately it seems that we don't normalise `account` data
   * in some of the Flux Stores, hence additional coalescing logic to make it
   * a bit more universal.
   */
  const capabilities = account.actionsAvailable ?? account.actions_available;
  return capabilities?.[ENRICHED];
};

export const hasExceededYouthAccountPaymentLimit = (amount) =>
  AccountsStore.isYouthAccount() && amount > YOUTH_ACCOUNT_PAYMENT_LIMIT;
